








import {Component, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import Navbar from '@/components/SignUp/Navbar.vue';
import {Action, Mutation, namespace, State} from 'vuex-class';
import {MAFUser} from '@/store/User/types'; // @ is an alias to /src

const userPath = 'userState';
const userNamespace = namespace(userPath);
@Component({
  components: {
    Navbar, BButton,
  },
})
export default class SignUp extends Vue {
  @userNamespace.State('self') public myself: MAFUser | undefined;
  @userNamespace.Action('getDiagnosis') public getDiagnosis: any;
  @userNamespace.Action('getUserType') public getUserType: any;
  @userNamespace.Action('getActivities') public getActivities: any;
  @userNamespace.Action('getGroupActivities') public getGroupActivities: any;
  @userNamespace.Action('getDistances') public getDistances: any;
  @Action('SignOut') public SignOut: any;
  @userNamespace.Mutation('setSignUpPhase') public setSignUpPhase: any;
  @Mutation('setSelf', {namespace: 'userState'}) public setSelf: any;

  public BASE_URL: string;
  public showSignIn: boolean;
  public currentPhase: number;

  constructor() {
    super();
    this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
    this.showSignIn = true;
    this.currentPhase = 0;
  }

  public async mounted() {
    // only get signup info if user hasn't completed signup
    if ( this.myself && this.myself.signUpPhase !== -1 ) {
      this.currentPhase = (this.myself.signUpPhase) ? this.myself.signUpPhase : 0;
      await this.getDiagnosis();
      await this.getUserType();
      await this.getGroupActivities();
      await this.getDistances();
      await this.getActivities();
    } else if ( this.myself ) {
      // there is a user & they've finished creating an account
      this.$router.push('/');
    }
  }

  // start over button was clicked - nav back
  public async updateState() {
    if ( this.currentPhase ) {
      if (this.myself && this.myself.userType
        && this.myself.userType === 'Parent/Caregiver'
        && this.currentPhase === 6) {

        this.setSignUpPhase( 1 );
      } else if (this.myself && this.myself.userType
        && this.myself.userType === 'Parent/Caregiver'
        && this.currentPhase === 4) {

        this.setSignUpPhase( 6 );

      } else {

        this.setSignUpPhase( this.currentPhase - 1 );
      }

      if (this.currentPhase - 1 !== 0 ) {
        // update self four phase & routing
        this.setSelf(this.myself);
      } else {
        // if they've backed the whole way out, sign them out
        await this.SignOut();
        await this.setSelf(undefined);
        this.$router.push('/');
        location.reload();
      }

    } else {
      await this.SignOut();
      await this.setSelf(undefined);
      this.$router.push('/');
      location.reload();
    }
  }
}
